import { type IApiResponse } from '@/helpers/types';
import { getCommandQuery, type IGetQuery } from '@/store/actions/api-utils';

import { coreApiSlice } from '../apiSlice';

const quickActionsApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createQuickActions: builder.mutation<IApiResponse, { name: string }>({
			query: (body) => ({
				method: 'POST',
				url: '/QuickActions',
				body,
			}),
		}),
		getQuickActions: builder.query<IApiResponse, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/QuickActions${getCommandQuery(paged, ...(query || []))}`,
			}),
		}),
	}),
});

export const { useCreateQuickActionsMutation, useGetQuickActionsQuery } = quickActionsApiSlice;
